import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { computed, reactive } from "vue"
import { Linter } from "eslint"
import type { Linter as LinterType } from "eslint"
import * as vueParser from "vue-eslint-parser"
import globals from "globals"
import { rules as vueRules, processors } from "eslint-plugin-vue"
import { rules as a11yRules } from "eslint-plugin-vuejs-accessibility"
import EslintEditor from "@ota-meshi/site-kit-eslint-editor-vue"

const linter = new Linter({ configType: "flat" })

const loadedParsers = reactive({
  parsers: { "@typescript-eslint/parser": false } as Record<string, any>,
})
// @ts-expect-error -- use require-parser
window.loadedParsers = loadedParsers

const plugins = {
  vue: {
    rules: vueRules,
    processors,
  },
  "vuejs-accessibility": {
    rules: a11yRules,
  },
}

const __default__ = {}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ESLintEditor',
  props: {
  modelValue: {
    type: String,
    default: "",
  },
  rules: {
    type: Object,
    default() {
      return {}
    },
  },
  parser: {
    type: [String, Object],
    default: undefined,
  },
},
  emits: {
  "update:modelValue": (value: string) => true,
  "update-messages": (messages: any[]) => true,
},
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit

const resolvedParser = computed(() =>
  !props.parser || props.parser === "espree" ? undefined : props.parser,
)
const parserList = computed((): string[] => {
  const parser = resolvedParser.value
  if (!parser) {
    return []
  }
  if (typeof parser === "string") {
    return [parser]
  }
  return Object.values(parser) as string[]
})

const resolvedLinter = computed(() => {
  if (!resolvedParser.value) {
    return linter
  }
  for (const parser of parserList.value) {
    if (!loadedParsers.parsers[parser]) {
      // eslint-disable-next-line vue/no-async-in-computed-properties -- ignore
      loadParser(parser).catch((e) => {
        throw e
      })

      return null
    }
  }

  return linter
})
const config = computed<LinterType.FlatConfig[]>(
  (): LinterType.FlatConfig[] => {
    return [
      {
        files: ["**"],
        processor: "vue/vue",
        plugins: plugins as any,
        languageOptions: {
          globals: {
            ...globals.builtin,
            ...globals.browser,
            ...globals.es2021,
            console: false,
            // ES2015 globals
            ArrayBuffer: false,
            DataView: false,
            Float32Array: false,
            Float64Array: false,
            Int16Array: false,
            Int32Array: false,
            Int8Array: false,
            Map: false,
            Promise: false,
            Proxy: false,
            Reflect: false,
            Set: false,
            Symbol: false,
            Uint16Array: false,
            Uint32Array: false,
            Uint8Array: false,
            Uint8ClampedArray: false,
            WeakMap: false,
            WeakSet: false,
            // ES2017 globals
            Atomics: false,
            SharedArrayBuffer: false,
          },
          parser: vueParser,
          parserOptions: {
            ecmaVersion: "latest",
            sourceType: "module",
            parser: resolvedParser.value,
          },
        },
        rules: props.rules,
      },
    ]
  },
)

/**
 * Load parser
 */
async function loadParser(parser: string) {
  if (parser === "@typescript-eslint/parser") {
    loadedParsers.parsers["@typescript-eslint/parser"] = await import(
      "@typescript-eslint/parser"
    )
  }
}

/**
 * Handle input event
 */
function onInput(value: string) {
  emits("update:modelValue", value)
}

/**
 * Handle change event
 */
function onChange(data: { messages: any[] }) {
  emits("update-messages", data.messages)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(EslintEditor), {
    linter: resolvedLinter.value,
    config: config.value as any,
    code: __props.modelValue,
    class: "eslint-code-block",
    filename: "ExampleComponent.vue",
    language: "html",
    dark: "",
    format: {
      insertSpaces: true,
      tabSize: 2,
    },
    fix: "",
    "onUpdate:code": onInput,
    onChange: onChange
  }, null, 8, ["linter", "config", "code"]))
}
}

})